import { render, staticRenderFns } from "./LicenseNotification.vue?vue&type=template&id=69dca006"
import script from "./LicenseNotification.vue?vue&type=script&lang=js"
export * from "./LicenseNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports